import { DietMealItemComponent } from '../diet-meal-item/diet-meal-item.component';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNumber } from 'lodash';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
  selector: 'app-diet-plan-history',
  standalone: false,
  templateUrl: './diet-plan-history.component.html',
  styleUrl: './diet-plan-history.component.scss'
})

export class DietPlanHistoryComponent extends DietMealItemComponent {
  datasource: any
  dialogData: any
  dietHistory: any[] = [];
  meal_timing: any;
  currentDietPlanData: any
  currentResource: any = "diet_plan_history_details"
  currentDietplan: any
  constructor(
    public baseService: BaseService,
    public alerts: AlertsService,
    public loader: LoaderService,
    public dialogConfig: DialogConfig,
    public dialog: DialogRef,
    public Aroute: ActivatedRoute,
    public router: Router,
    public utilService: UtilService,
    public cdr: ChangeDetectorRef
  ) {
    super(baseService, alerts, loader, dialogConfig, dialog, Aroute, router, utilService, cdr);
  }


  ngOnInit(): void {
    this.dialogData = this.dialogConfig.data;
    if (this.dialogData.item.status == 'active') {
      this.getCurrentDietPlan(this?.dialogData?.action, this.dialogData)
    }
    this.datasource = this.makeargs(this?.dialogData?.action?.dietHistoryDatasource?.datasource)
    this.getDietPlanHistory()
    this.getMealTiming((meal_time_data) => {
      if (meal_time_data && meal_time_data.length > 0) {
        this.meal_timing = meal_time_data;
      }
    });
    this.cdr.detectChanges();

  }

  makeargs(datasource?) {
    datasource = JSON.parse(JSON.stringify(datasource));
    datasource.args = this.baseService.buildDyanamicStr(datasource.args, { data: this.dialogConfig.data.item });
    datasource.filter = this.baseService.buildDyanamicStr(datasource.filter, { data: this.dialogConfig.data.item });
    return datasource;
  }

  getDietPlanHistory() {
    this.baseService.getData({ args: this.datasource.args, filter: this.datasource.filter, page_size: this.datasource.page_size, page_no: this.datasource.page_no }, '', this.datasource.resource, this.datasource.application, this.datasource.query_id)?.subscribe((res) => {
      if (res.errCode == 0 && res.resource) {
        setTimeout(() => {
          if (this.currentDietplan) {
            res.resource.push(this.currentDietplan)
          }
          if (res.resource?.length == 0 && !this.currentDietplan) {
            this.alerts.info("No diet order exists for this diet plan!");
            this.dialog.close();
          }
          this.dietDetails = { resource: res.resource };
          this.changedMealData();
        }, 300);
      }
    });
  }


  changedMealData() {
    const _khaliObj = {};
    this.dietDetails?.resource?.forEach(item => {
      const key = item.orderPlacedForDate;
      _khaliObj[key] ??= { orderPlacedForDate: key, mealDefinition: [] };
      if (isNumber(key)) {
        _khaliObj[key].mealDefinition.push({
          mealTimeCode: item.mealTimeCode,
          id: item.mealTime,
          mealItemsDefinition: item.mealItemsDefinition ? item.mealItemsDefinition : item.mealDefinition,
          vendor_code: item.vendor_code
        });
      }
      else {
        (item.mealDefinition || []).forEach(element => {
          _khaliObj[key].mealDefinition.push({
            mealTimeCode: element?.mealTimeCode,
            id: element?.mealTime,
            mealItemsDefinition: element?.mealItemsDefinition,
            vendor_code: element?.vendor_code
          });
        });
      }
    });
    this.dietHistory = Object.values(_khaliObj);
    //  this.dietHistory.sort((a: any, b: any) => b.orderPlacedForDate - a.orderPlacedForDate);
    this.dietHistory = this.dietHistory.map(x => ({ ...x, mealDefinition: x.mealDefinition.sort((a, b) => a.mealTimeCode.localeCompare(b.mealTimeCode)) })).sort((a, b) => a.orderPlacedForDate === 'Current Diet Plan' ? -1 : b.orderPlacedForDate === 'Current Diet Plan' ? 1 : b.orderPlacedForDate - a.orderPlacedForDate);
    //this.dietHistory.sort((a: any, b: any) => b.orderPlacedForDate === 'Current Diet Plan' ? 1 : a.orderPlacedForDate === 'Current Diet Plan' ? -1 : b.orderPlacedForDate - a.orderPlacedForDate);
    this.dietHistory.forEach((item: any, index) => {
      const mealTiming = item.mealDefinition?.map((meal: any) => {
        return this.meal_timing.find((mt: any) => mt.mealTimeCode === meal.mealTimeCode)
      }).filter(Boolean);
      item.meal_timing = mealTiming;
    });

    this.dietHistory.forEach((item: any, index: number) => {
      item.meal_timing?.forEach((timing: any, indexes: number) => {
        this.showHideAccordian(indexes)
      });
    });
    this.cdr.detectChanges();
  }


  getConfig(meal_time, history?) {
    const mealData = history?.mealDefinition?.find((meal) => meal.mealTimeCode == meal_time);
    this.config = Object.assign({}, this.config, { items: mealData?.mealItemsDefinition || [] });
    return this.config;
  }


  getCurrentDietPlan(event?, items?) {
    let bannerData = event?.banner?.datasource;
    this.baseService.get("GET_BY_ID", `id:${items.item.id}`, bannerData.resource, bannerData.application).subscribe((result: any) => {
      if (result.errCode == 0 && result.resource) {
        this.currentDietplan = Object.assign({}, result.resource[0], { orderPlacedForDate: 'Current Diet Plan' })
      }
    })
  }

  getHeader(value: any) {
    if (!isNaN(value)) {
      return new Date(Number(value)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    return value;
  }


  ngOnDestroy() {
    this.cdr.detectChanges();
  }



}
